// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
export var COLORS = {
    primary: '#4388dd',
    font: '#212B36',
    success: '#65cd45',
    warning: '#f87c4f',
    error: '#f1585b',
    info: '#3aa0ff',
};
